import * as React from 'react';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

export function PipelinesFeatureGateModal() {
    const {onClose} = useOpenableModal(OpenableModals.PIPELINES_FEATURE_GATE_MODAL);
    const hasDraftPipelines = NutClientConfig.hasDraftPipelinesFF;

    return (
        <FeatureGateModalWrapper
            isOpen={true}
            onClose={onClose}
            title={
                hasDraftPipelines
                    ? 'Upgrade for more active pipelines'
                    : 'Upgrade for more pipelines'
            }
            description={
                hasDraftPipelines
                    ? 'Upgrade now and take your CRM experience to the next level. If you’re at your active pipeline limit:'
                    : 'Upgrade now and take your CRM experience to the next level. By upgrading, you will gain:'
            }
            bullets={
                hasDraftPipelines
                    ? [
                          'Archive or deactivate an existing active pipeline, or upgrade your plan to create more.',
                          'To archive or deactivate a pipeline, ensure all leads within are closed or resolved first.',
                      ]
                    : [
                          'Use multiple pipelines to customize sales processes',
                          'Close more leads by creating tailored pipelines for different markets',
                          'Access to other premium tools and integrations',
                      ]
            }
            feature={hasDraftPipelines ? 'activePipelines' : 'multiplePipelines'}
            limitsType='PIPELINES'
        />
    );
}
